import React from 'react'
import InfoBox from '@components/InfoBox'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'

const FormError = ({ error, className }) => {
  if (!error) return null

  let errorMessage
  if (error.message) {
    errorMessage = error.message
  } else if (error.error) {
    errorMessage = error.error
  } else if (typeof error === 'string') {
    errorMessage = error
  } else {
    errorMessage =
      'An unkown error occured while submitting the form please try again'
  }

  return (
    <InfoBox className={className} theme='red'>
      {errorMessage}
    </InfoBox>
  )
}

FormError.propTypes = {
  error: PropTypes.object,
  className: PropTypes.string
}

FormError.defaultProps = {
  loading: false,
  className: 'm-b-lg'
}

export default observer(FormError)
